import {Injectable} from '@angular/core';
import { Headers, Response, URLSearchParams, RequestOptions, ResponseContentType } from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ReportService {

  private reportUrl: string = `${ environment.apiRoot }/report/`;
  private urlPDF: string = `${ environment.apiRoot }/pdf-report/`;

  constructor(private http: HttpAuth) { }

  public getReportByid(jobId: string): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (jobId != null) {
      params.append('jobid', String(jobId));
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.reportUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public getDossierPDF (job_id): Observable<any> {
    return this.http.get(this.urlPDF+"?job_id="+job_id, {responseType: ResponseContentType.Blob})
      .map(
          res=>new Blob ([res.blob()], {type: res.headers.get('Content-Type')})
        )
      .catch(this.handleError);
  }
  
  public putReport(job_id:string, description:string, appliers:any, email = ''): Observable<any> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    let params: URLSearchParams = new URLSearchParams();
    let data = {};
    if (email == ''){
      let data = {
        'job_id' : job_id,
        'more_info' : description,
        'appliers' : appliers,
      }
    }else{
      data = {
        'job_id' : job_id,
        'more_info' : description,
        'appliers' : appliers,
        'email' : email,
      }
    }

    let options = new RequestOptions({search: params});

    return this.http.put(this.reportUrl, data,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postReport(job_id:string, description:string, appliers:any, email = ''): Observable<any> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    let params: URLSearchParams = new URLSearchParams();
    let data = {};
    if (email == ''){
      data = {
        'job_id' : job_id,
        'more_info' : description,
        'appliers' : appliers,
      }
    }else{
      data = {
        'job_id' : job_id,
        'more_info' : description,
        'appliers' : appliers,
        'email' : email,
      }
    }

    let options = new RequestOptions({search: params});

    return this.http.post(this.reportUrl, data,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();
    console.log(res);
    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /Users/everis/code/Dj/front.staff/src/app/services/report.service.ts